import { z } from 'zod';
import { idSchema } from './common.schemas';
import { defineListQuery, listFilter } from './list-query.schemas';

/** `OverrideService.record()` — a reason and an approver are required arguments, never optional (gitaumoses4/chukua#7). */
export const recordOverrideSchema = z.object({
  kind: z.string().trim().min(1).max(64),
  entityType: idSchema,
  entityId: idSchema,
  reason: z.string().trim().min(1).max(500),
  requestedBy: idSchema,
  approverId: idSchema,
});
export type RecordOverrideInput = z.infer<typeof recordOverrideSchema>;

/** `GET /overrides` — the M11 override report: by kind, by user, by period. */
export const overrideListQuerySchema = defineListQuery({
  sortFields: ['occurredAt', 'kind'],
  defaultSort: { sort: 'occurredAt', order: 'desc' },
  filters: {
    kind: listFilter(z.string().min(1).max(64)),
    requestedBy: listFilter(idSchema),
    approverId: listFilter(idSchema),
    occurredFrom: z.coerce.date().optional(),
    occurredTo: z.coerce.date().optional(),
  },
});
export type OverrideListQuery = z.infer<typeof overrideListQuerySchema>;
